<template>
  <div class="finance-order-item">
    <div class="summary-bar">
      <div class="col sn">订单号： {{ order.orderSn }}</div>
      <div class="col seller-name">卖家： {{ order.subSellerName }}</div>
      <div class="col time" v-if="order.timePay">付款时间：{{ order.timePay | dateTimeFmt }}</div>
      <div class="col time" v-else>下单时间：{{ order.createTime | dateTimeFmt }}</div>
      <div class="col buyer-info">买家：{{ order.buyerName }}/{{ order.buyerPassportName }}/{{ phoneShow(order.phone) }}</div>
    </div>
    <div class="items">
      <div class="col parts">
        <div class="part-row" v-for="item in order.items.slice(0, collapse ? 5 : order.items.length)" :key="item.orderItemId">
          <div class="cell code">
            <div>{{ item.name }}</div>
            <div>
              <span v-if="item.supersession && item.supersession !== item.sn">
                {{ item.supersession }}
                <el-tooltip v-if="item.systemDiffPrice" :content="`替换件差价:${item.systemDiffPrice}`">
                  <span class="superssion-badge">替</span>
                </el-tooltip>
                <span v-else class="superssion-badge">替</span>
                /
              </span>
              {{ item.sn }}
            </div>
          </div>
          <div class="cell warehouse">
            {{ orderBrands[item.brandCode] || '其他' }}|{{ item.warehouse || '上海' }}
          </div>
          <div class="cell count">
            <div>{{ item.quantity }}</div>
            <el-button type="text" style="padding: 0" @click="showReturn(item.orderItemId)" v-if="order.invoiceOrderId === 0 && item.quantityReturn > 0">(售后:{{ item.quantityReturn }})</el-button>
          </div>
          <div class="cell price">
            <div><label>单价：</label><span style="font-size: 11px;">&yen;</span>{{ item.price | currencyFmt }}</div>
            <div v-if="item.cost4S"><label>4S进价：</label><span style="font-size: 11px;">&yen;</span>{{ item.cost4S | currencyFmt }}<label>({{ item.price / item.cost4S | discountFmt }})</label></div>
          </div>
        </div>
      </div>
      <div class="col amount">
        <div>&yen;{{ order.amountPay | currencyFmt }}</div>
        <div v-if="order.payType" style="margin-top: 6px;">
          <span class="pay-type">{{ payTypes[order.payType] }}</span>
        </div>
      </div>
      <div class="col state">
        <div>{{ orderStateEnums[order.state] }}</div>
        <div>
          <el-button type="text" @click="$router.push(`financeorder/${order.id}`)">订单详情</el-button>
        </div>
      </div>
    </div>
    <div v-if="order.items.length > 5" class="folder-row">
      <span @click="collapse = !collapse">
        {{ collapse ? `展开剩余${order.items.length - 5 }条` : '收起' }}
        <i v-if="collapse" class="el-icon-arrow-down" />
        <i v-else class="el-icon-arrow-up" />
      </span>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FinanceOrderItem',
  filters: {
    discountFmt (val) {
      return (val * 10).toFixed(1) + '折'
    }
  },
  props: {
    order: {
      type: Object,
      default () {
        return {
          id: '',
          orderSn: '',
          buyerName: '',
          items: []
        }
      }
    }
  },
  data () {
    return {
      collapse: true
    }
  },
  computed: {
    payTypes () {
      return this.$store.state.payTypes
    },
    orderStateEnums () {
      const stateDict = {}
      this.$store.state.orderState.forEach(item => {
        stateDict[item.id] = item.name
      })
      return stateDict
    },
    orderBrands () {
      const brandDict = {};
      (this.$store.state.orderBrands || []).forEach(item => {
        brandDict[item.code] = item.name
      })
      return brandDict
    }
  },
  methods: {
    showReturn (orderItemId) {
      this.modal('OrderReturnDetailModal', orderItemId).promise.catch(() => {})
    }
  }
}
</script>
